<template>
    <div>
        <!--  <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Genrate Challan</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-row justify="center">
                <!-- <v-col cols="12" sm="4" md="4">
                    <v-icon color="error">*</v-icon>
                    <v-text-field outlined rounded color="#0F2027" dense placeholder="Enter PRN No" v-model="selected_children" type="text" hint="For example :: 121/111" @click="show = false"></v-text-field>
                </v-col> -->
                 <v-col cols="12" sm="4" md="4">
                    <v-autocomplete v-model="selected_children" rounded :items="stud_list" item-value="registration_number" label="Select Student" item-text="name" outlined dense prepend-icon="mdi-account-child-circle"></v-autocomplete>
                </v-col>
                <v-col cols="3">
                    <v-select rounded :items="aylist" label="Academic Year" item-text="academicyear" item-value="ay_id" outlined dense v-model="ay"></v-select>
                </v-col>
                <v-btn class="button mt-9" v-if="selected_children != null" @click="getDetails()">Proceed</v-btn>
            </v-row>
        </v-card>
        <v-card class="box" v-if="this.show_details_card">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Student Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="5">
                    <v-text-field rounded class="padding-bot" label="Name" readonly outlined dense v-model="fees_student_master_details.name"></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field rounded class="padding-bot" label="Standard" readonly outlined dense v-model="fees_student_master_details.standard"></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field rounded class="padding-bot" label="Quota" readonly outlined dense v-model="fees_student_master_details.quota"></v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center">
                <v-col cols="3">
                    <v-text-field rounded class="padding-bot" label="Total Fees" readonly outlined dense v-model="fees_student_master_details.total_fees_amount"></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field rounded class="padding-bot" label="Amount Paid" readonly outlined dense v-model="fees_student_master_details.paid_till_now"></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field rounded class="padding-bot" label="Balance Fees" readonly outlined dense v-model="fees_student_master_details.balance_amount"></v-text-field>
                </v-col>
                 <v-col cols="2" v-if=" this.show_receipts_btn">
                    <v-btn class="ma-2" color="error" @click="expand = !expand">
                        Previous Challan
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-expand-transition>
            <v-card v-show="expand" class="box">
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>Student Preveious Challan</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br />
                <template v-if="student_challan_details != ''">
                    <v-data-table :items="student_challan_details" :headers="headers" class="elevation-1 mytable" dense :search="search">
                        <template v-slot:item.print="{ item }">
                            <v-tooltip top color="warning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="pt-none mt-none" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="print(item.challan_no,item.academicyear)"> <v-icon color="warning">mdi-printer</v-icon>Print Challan</v-btn>
                                </template>
                                <span>
                                    Print Challan!!!
                                </span>
                            </v-tooltip>
                        </template>
                        <template v-slot:item.status="{ item }">
                             <v-select dense rounded required class="mt-1" :items="challan_status_list" item-text="display_name" return-object v-model="item.challanstatus" placeholder="Selct Challan Status" outlined></v-select>
                        </template>
                         <template v-slot:item.remark="{ item }">
                            <v-text-field rounded  label="Remark" outlined dense v-model="item.remark"></v-text-field>
                        </template>
                        <template v-slot:item.update="{ item }">
                             <v-btn class="pt-none mt-none button" outlined rounded small  @click="chnagechallanstatus(item.challanstatus,item.id,item.remark)">Update</v-btn>
                        </template>
                    </v-data-table>
                </template>
            </v-card>
        </v-expand-transition> 

        <!--    <v-row justify="center" v-if=" this.show_installments_btn">
                <v-btn class="ma-2" color="error" @click="expand1 = !expand1">
                    Installments
                </v-btn>
            </v-row>
            <v-expand-transition>
                <v-card v-show="expand1" class="box">
                    <v-card-text>
                        <template v-if="installment_list != ''">
                        <v-toolbar dense class="toolbar" flat color="white">
                            <v-toolbar-title>Student Installments</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <br>
                            <v-data-table :items="installment_list" :headers="headers_installment" dense :search="search" class="elevation-1 mytable"> </v-data-table>
                        </template>
                    </v-card-text>
                </v-card>
            </v-expand-transition> -->

        <v-card class="box" v-if="installment_details_list!=''">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Fees Component</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-col cols="12" sm="12" md="12">
                <v-row dense>
                    <v-col cols="12" sm="2" md="2">
                        <v-select dense rounded required :items="mode_list" item-text="name" return-object v-model="mode" label="Payment Mode" placeholder="Selct Mode" outlined></v-select>
                    </v-col>
                    <!--<v-col cols="12" sm="2" md="2" v-if="mode">
                        <v-autocomplete dense rounded v-if="mode.name!='Cash'" required :items="bank_list" v-model="bank" label="Bank" name="bank" item-text="name" item-value="id" outlined></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="mode">
                        <v-text-field rounded v-if="mode.name!='Cash'" class="padding-bot" label="DD / Check No." outlined dense v-model="cheque_dd_no"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" v-if="mode" class="ml-3 mt-3">
                        <span v-if="mode.name!='Cash'"> DD/Cheque Date </span>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="mode" class="mt-2"> : <input class="p-0 m-0" v-if="mode.name!='Cash'" id="datePickerId" type="date" v-model="mode_date" dense /> </v-col> -->
                </v-row>
                <v-simple-table dense class="elevation-1 mytable" v-if="mode">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th>Component</th>
                                <th>Actual</th>
                                <th>Paid</th>
                                <th>Balance</th>
                                <th>Pay Now</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="comp in installment_details_list" :key="comp.id">
                                <td>{{ comp.name }}</td>
                                <td>{{ comp.amount }}</td>
                                <td>{{ comp.paid_amount }}</td>
                                <td>{{ comp.balance_amount }}</td>
                                <td>
                                    <!-- <v-text-field v-if="comp.balance_amount != 0" outlined rounded dense placeholder="Enter Payable Amount." dense class="pt-1 pb-1" v-model="comp.current_amount" type="number" hint="For example :: 100/200"></v-text-field>
                                <v-text-field v-else outlined rounded dense readonly placeholder="Enter Payable Amount." dense class="pt-1 pb-1" v-model="comp.current_amount" type="number" hint="For example :: 100/200"></v-text-field> -->
                                    <input  placeholder="Enter Amount." class="input text-center"  type="number" v-model="comp.current_amount" :name="comp.id" :rules="[v => !!v || 'Required' || v >= 0]" @change="check_ammount(comp.current_amount,comp.balance_amount)" />
                                   <!-- <input v-else class="input text-center" readonly type="number" v-model="comp.current_amount" :name="comp.id" :rules="[v => !!v || 'Required' || v >= 0]" /> -->
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <v-row dense justify="center" v-if="mode"> <v-btn class="button mt-9" @click="generateChallan(installment_details_list)">Generate Challan</v-btn></v-row>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
    import datetime from "vuejs-datetimepicker";
    import moment from "moment";
    import DatePicker from "vue2-datepicker";
    export default {
        components: {
            Datepicker,
            DatePicker,
            datetime,
        },
        data: () => ({
            show: false,
            selected_children: "",
            child_notice: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            current_ay: "",
            search: "",
            s3url: "",
            installment_list: [],
            installment: "",
            installment_details_list: [],
            fees_student_master_details: [],
            mode_list: [],
            mode: null,
            student_challan_details: [],
            show_details_card: false,
            show_receipts_btn: false,
            show_installments_btn: false,
            expand: false,
            expand1: false,
            headers: [
                { text: "Sr. No", value: "srno", sortable: true },
                { text: "Challan No", value: "challan_no", sortable: true },
                { text: "Amount", value: "amount", sortable: true },
                { text: "Date", value: "challan_date", sortable: true },
                {text: "Challan Status", value: "status", sortable: true},
                {text: "Challan Remark", value: "remark", sortable: true},
                {text: "Update", value: "update", sortable: true},
                { text: "Print Challan", value: "print", sortable: true },
            ],
            headers_installment: [
                { text: "Sr. No.", value: "srno", sortable: true },
                { text: "Payment Stage", value: "installment", sortable: true },
                { text: "Amount", value: "total_fees_amount", sortable: true },
                { text: "Fine", value: "fine", sortable: true },
                { text: "Deadline", value: "due_date", sortable: true },
            ],
            components_value: [],
            components_id: [],
            receipt_amount: 0,
            bank_list: [],
            bank: null,
            mode_date: null,
            cheque_dd_no: null,
            challan_no: null,
            ay: null,
            challan_status_list:[],
            challan_status:null,
            stud_list: [],
            aylist: [],
            ay: "",
        }),

        methods: {
            chnagechallanstatus(challanstatus,challan,remark){ 
                 const formData = {
                   challanstatus:challanstatus.id,
                   challan:challan,
                   remark:remark
                };
                axios
                    .post("GenerateChallan/changeChallanStatus", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                           this.showSnackbar("#4CAF50", " Challan Status changed Successfully..");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.clearData();
                    })
                    .finally(() => {
                        this.getDetails();
                    });
            },
            check_ammount(current_amount,balance_amount){
                    if(current_amount > balance_amount){
                        this.showSnackbar("#b71c1c", "Amount should be less than balance amount");
                        return;
                    }
            },
            print(challan_no, academicyear) {
                //alert(receipt_no)
                this.challan_no = challan_no;
                this.ay = academicyear;
                this.dialog_print = true;
                // this.overlay = true
                this.$session.set("challan_no", JSON.stringify(challan_no));
                this.$session.set("ay", JSON.stringify(this.ay));
                this.$session.set("registration_no", JSON.stringify(this.selected_children));
                // this.$router.push({
                //     name: "student-generate-challan",
                // });
                let routeData = this.$router.resolve({name: 'student-generate-challan'});
                window.open(routeData.href, '_blank');
            },
            clearData() {
                this.fees_student_master_details = [];
                this.student_receipt_details = [];
                this.show_details_card = false;
                this.show_receipts_btn = false;
                this.show_installments_btn = false;
                this.installment_list = [];
                this.mode_list = [];
                this.bank_list = [];
                this.challan_status_list=[];
                this.challan_status=null;
                this.installment_details_list = [];
                this.stud_name = null;
                this.comp_total = "";
                this.stud_id = "";
                (this.components_value = []), (this.components_id = []), (this.receipt_amount = 0);
                (this.mode = null), (this.bank = null), (this.cheque_dd_no = null), (this.mode_date = null);
            },
            generateChallan(installment_details_list) {
                for (var i = 0; i < installment_details_list.length; i++) {
                    if (installment_details_list[i].current_amount > 0) {
                        if(installment_details_list[i].current_amount > installment_details_list[i].balance_amount){
                            this.showSnackbar("#b71c1c", "Amount should be less than balance amount");
                            return;
                        }
                        this.components_id.push(installment_details_list[i].fc_id);
                        this.components_value.push(installment_details_list[i].current_amount);
                        this.receipt_amount += parseFloat(installment_details_list[i].current_amount);
                    }
                }
                const formData = {
                    registration_no: this.selected_children,
                    components_value: this.components_value,
                    components_id: this.components_id,
                    receipt_amount: this.receipt_amount,
                    mode: this.mode.id,
                    bank: this.bank,
                    cheque_dd_no: this.cheque_dd_no,
                    check_dd_date: this.mode_date,
                    ay:this.ay
                };
                axios
                    .post("GenerateChallan/generateChallan", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", " Challan Generated Successfully..");
                            // this.challan_no = res.data.challan_no;
                            // this.ay = res.data.ay;
                            // this.$session.set("challan_no", JSON.stringify(this.challan_no));
                            // this.$session.set("ay", JSON.stringify(this.ay));
                            // this.$session.set("registration_no", JSON.stringify(this.selected_children));
                            // let routeData = this.$router.resolve({name: 'student-generate-challan'});
                            // window.open(routeData.href, '_blank');
                            this.clearData();
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.clearData();
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.clearData();
                    })
                    .finally(() => {
                        this.clearData();
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getDetails() {
                if (this.selected_children == "") {
                    this.showSnackbar("#b71c1c", "Please Enter Registration No");
                    return;
                }
                const formData = {
                    registration_no: this.selected_children,
                    ay:this.ay
                };
                axios
                    .post("GenerateChallan/getLearnerData", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.installment_list = res.data.installments_details;
                            this.installment_details_list = res.data.installments;
                            this.fees_student_master_details = res.data.fees_student_master_details;
                            this.student_challan_details = res.data.student_challan_details;
                            this.mode_list = res.data.mode_list;
                            this.bank_list = res.data.bank_list;
                            this.challan_status_list = res.data.challan_status_list;
                            this.show_details_card = true;
                            this.show_receipts_btn = true;
                            this.show_installments_btn = true;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            onload() {
                axios
                    .post("FeesStructureInstallment/getdata")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.aylist = res.data.aylist), (this.ay = res.data.curreny_ay);
                            this.stud_list = res.data.stud_list;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
        },

        mounted() {
             this.onload();
            this.org_id = localStorage.getItem("EPS-tenant");
            // datePickerId.min = new Date().toISOString().split("T")[0];
        },
    };
</script>

<style scoped>
input[type=number] {
  width: 50%;
  display: inline-block;
  border: 1px solid black;
  border-radius: 4px;
  box-sizing: border-box;
}

    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .datepicker-div {
        margin-top: none !important;
    }
    .datepicker-div label {
        color: #00000099;
        font-size: 12px;
        position: relative;
    }
</style>
